import { Phone, Mail, MapPin } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_ed2227e8-f42f-486d-80b3-32e833e48098/artifacts/o750zne6_72B3D45F-1688-469F-935E-BB6BB3789CC9.png";

// NOTE: placeholders — update with real business info
const PHONE = "(819) 328-7598";
const EMAIL = "info@capitalshield.ca";
const AREA = "Ottawa & surrounding regions";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="relative border-t border-white/10 bg-[#050B14]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO} alt="Capital Shield" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-display text-lg font-bold tracking-wide">CAPITAL SHIELD</div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-[#9BD0E8]">
                  Sealing · Snow Removal
                </div>
              </div>
            </div>
            <p className="text-sm text-white/60 max-w-sm leading-relaxed">
              Ottawa's trusted shield for residential snow removal and driveway sealing.
              One local crew. Year-round protection.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#C9A24B] font-semibold mb-6">
              Contact
            </div>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#9BD0E8] mt-0.5" />
                <a href={`tel:${PHONE}`} data-testid="footer-phone" className="hover:text-[#C9A24B] transition-colors">
                  {PHONE}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#9BD0E8] mt-0.5" />
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="hover:text-[#C9A24B] transition-colors">
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#9BD0E8] mt-0.5" />
                <span data-testid="footer-area">{AREA}</span>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#C9A24B] font-semibold mb-6">
              Services
            </div>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="#services" className="hover:text-[#C9A24B] transition-colors">Residential Snow Removal</a></li>
              <li><a href="#services" className="hover:text-[#C9A24B] transition-colors">Salting & De-Icing</a></li>
              <li><a href="#services" className="hover:text-[#C9A24B] transition-colors">Driveway Sealing</a></li>
              <li><a href="#quote" className="hover:text-[#C9A24B] transition-colors">Get a Free Quote</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} Capital Shield. All rights reserved.
          </div>
          <div>
            <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-[#C9A24B] transition-colors">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
